import { useState } from 'react';
import { api } from '../api/client';
import type { RepeatOrderResult } from '../types/product';
import { buildRepeatOrderView } from './repeatOrderView';

/* ── CB-5 (1715d4b7): repeat a Completed order ──
 *
 * The button re-fills the cart through POST /orders/{id}/repeat: the
 * server re-adds every line that can honestly be repeated (products at
 * live validation; quote prints recalculated on the same model file and
 * re-verified against the current match list) and reports the rest per
 * line — the explicit «файл удалён» fallback rides skipReason. The card
 * mirrors the server's own copy instead of inventing reasons.
 * Light theme, minimal, per DESIGN-SYSTEM.md. */

const TONE_CLASS: Record<string, string> = {
  success: 'badge badge-success',
  accent: 'badge badge-warning',
  danger: 'badge badge-danger',
};

export function RepeatOrderBlock({ orderId }: { orderId: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<RepeatOrderResult | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      setResult(await api.repeatOrder(orderId));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось повторить заказ');
    } finally {
      setBusy(false);
    }
  };

  if (result) {
    const view = buildRepeatOrderView(result);
    return (
      <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)', padding: 'var(--space-md)' }}>
        <span className={TONE_CLASS[view.tone]}>{view.headline}</span>
        {view.skipLines.length > 0 && (
          <ul style={{ margin: 0, paddingLeft: 'var(--space-lg)', display: 'flex', flexDirection: 'column', gap: 'var(--space-xs)' }}>
            {view.skipLines.map((line, i) => (
              <li key={i} style={{ fontSize: 'var(--fs-body)', color: 'var(--color-text-secondary)' }}>
                {line.title} — {line.reason}
              </li>
            ))}
          </ul>
        )}
        <button
          className="btn btn-secondary"
          disabled={busy}
          onClick={() => { setResult(null); setError(null); }}
        >
          Повторить ещё раз
        </button>
      </div>
    );
  }

  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)', padding: 'var(--space-md)' }}>
      <button className="btn btn-primary" disabled={busy} onClick={() => { void submit(); }}>
        {busy ? 'Повторяем…' : 'Повторить заказ'}
      </button>
      {error && (
        <p role="alert" style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-danger, #E5484D)' }}>
          {error}
        </p>
      )}
    </div>
  );
}
